export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar?: string
}

export type CoachProfile = {
  name: string
  role: string
  bio: string
}

/**
 * Only real reviews from real buyers (with their permission).
 * The review sections only render when these arrays have items —
 * they stay empty until 52 Weeks of Speaking has verified reviews.
 */
export const coachProfiles: CoachProfile[] = []

export const shortTestimonials: Testimonial[] = []

export const moreTestimonials: Testimonial[] = []

/**
 * Real words from teachers and speaking-club members on public forums.
 * They describe the problem, they are NOT reviews of this product.
 */
export type ForumQuote = { quote: string; context: string }

export const forumQuotes: ForumQuote[] = [
  {
    quote: 'I’ve been doing this since September … and I’m running out of ideas.',
    context: 'Conversation-class teacher · ESL teachers’ forum',
  },
  {
    quote: 'Nothing that I found out there already presented the ‘meat’ … I wrote my own curriculum for it.',
    context: 'Speech teacher · homeschool teaching forum',
  },
  {
    quote: 'There’s an art to picking good topics.',
    context: 'Speaking-club member · online forum',
  },
]
